<template>
    <b-container class="py-4 text-center">
      <h2>Sign up to start creating your clone... 🤖</h2>
      <h5>Our AI takes 12-24 hours to create your clone. We will email you when it's ready.</h5>

      <LoadingButton size="lg" variant="primary" class="mt-2" :loading="loading" @click="start_trial">Start 7 day trial</LoadingButton>
    </b-container>
</template>

<script>

import { db, config, FieldValue } from '@/main.js'
import moment from 'moment/src/moment'

export default {
  metaInfo: {title: 'Onboarding wait'},
  props: ['profile', 'user'],
  data() {
    return {
      loading: false
    }
  },
  methods: {
    async start_trial() {
      this.loading = true

      let price_id = config.stripe.trial_price_usd
      if (this.profile.country === 'GB') {
        price_id = config.stripe.trial_price_gb
      }
      if (['AT', 'BE', 'FI', 'FR', 'DE', 'GR', 'IE', 'IT', 'LU', 'MT', 'PT', 'ES'].indexOf(this.profile.country) > -1) {
        price_id = config.stripe.trial_price_eur
      }

      const checkout_session_doc = await db.collection("customers").doc(this.profile.id).collection("checkout_sessions").add({price: price_id, at_period_end: true, trial_from_plan: true, success_url: `https://${config.firebase_config.domain}/dashboard`, cancel_url: `https://${config.firebase_config.domain}/`, allow_promotion_codes: true})
      checkout_session_doc.onSnapshot((snap) => {
        const { error, sessionId } = snap.data()
        if (error) { // TODO
          alert(`An error occured: ${error.message}`);
          return
        }

        if (sessionId) {
          /*eslint-disable */
          const stripe = Stripe(config.stripe.key)
          /*eslint-enable */
          stripe.redirectToCheckout({ sessionId })
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
